/* CONNEC — Chartes de grandeur : surligne la taille sélectionnée sur la fiche produit
   dans le tableau du tiroir « Guide des tailles ». Colonne (chartes vêtements, tête, chaussons)
   ou ligne (charte gants, où la taille est en première colonne). */
(function () {
  if (window.__connecSizeChart) return;
  window.__connecSizeChart = true;

  var ALIASES = { '2XL': 'XXL', '3XL': 'XXXL', '2X': 'XXL', '3X': 'XXXL', 'XXXL': 'XXXL' };

  function norm(text) {
    var v = (text || '').toUpperCase().replace(/\s+/g, '').replace(/[^\w\/]/g, '');
    return ALIASES[v] || v;
  }

  function cellText(cell) {
    var clone = cell.cloneNode(true);
    clone.querySelectorAll('small').forEach(function (s) { s.remove(); });
    return clone.textContent;
  }

  function selectedSize(drawer) {
    var fieldset = drawer.closest('fieldset');
    if (!fieldset) return '';
    var span = fieldset.querySelector('.variant-picker__option-info .h-stack span');
    return span ? norm(span.textContent) : '';
  }

  function highlight(drawer) {
    var wrap = drawer.querySelector('.connec-size-chart-wrapper');
    if (!wrap) return;
    wrap.querySelectorAll('.is-your-size').forEach(function (el) {
      el.classList.remove('is-your-size');
      el.removeAttribute('data-label');
    });
    var value = selectedSize(drawer);
    if (!value) return;
    var label = drawer.getAttribute('data-your-size-label') || '';

    wrap.querySelectorAll('table').forEach(function (table) {
      var ths = table.querySelectorAll('thead th');
      var col = -1;
      ths.forEach(function (th, i) { if (i > 0 && norm(th.textContent) === value) col = i; });
      if (col > -1) {
        ths[col].classList.add('is-your-size');
        ths[col].setAttribute('data-label', label);
        table.querySelectorAll('tbody tr').forEach(function (tr) {
          var td = tr.children[col];
          if (td) td.classList.add('is-your-size');
        });
        return;
      }
      table.querySelectorAll('tbody tr').forEach(function (tr) {
        var td = tr.children[0];
        if (td && norm(cellText(td)) === value) {
          tr.classList.add('is-your-size');
          td.setAttribute('data-label', label);
        }
      });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('button[aria-controls^="size-chart-"]');
    if (!button) return;
    var drawer = document.getElementById(button.getAttribute('aria-controls'));
    if (drawer) highlight(drawer);
  }, true);
})();
